import { render, staticRenderFns } from "./Acknowledge.vue?vue&type=template&id=0cf07067"
import script from "./Acknowledge.vue?vue&type=script&lang=js"
export * from "./Acknowledge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports